import React, { Component } from "react";
import PropTypes from "prop-types";

export default function(ComposedComponent) {
  class Authentication extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    componentWillUpdate() {
      console.log("willupdate",localStorage)
      if (!localStorage.getItem("sessionKey")) {
          console.log("ok");
          localStorage.clear();
        //this.context.router.history.push("/");
        
        this.props.history.push("/");
      }
    }

    componentWillMount() {
      console.log('thiscontext', this)
      console.log("willmount",localStorage)
      if (!localStorage.getItem("sessionKey")) {
          console.log("clearing sessionkey");
          localStorage.clear();
        //this.context.router.history.push("/");
        
        this.props.history.push("/");
      }
      else{
        console.log('authenticated')
      }

    }

    render() {
      if (!localStorage.getItem("sessionKey")) {
        return null;
      }
      return <ComposedComponent {...this.props} />;
    }
  }

  return Authentication;
}



// WEBPACK FOOTER //
// ./src/components/requireAuth.js